import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  playNext: false,
};

const authAnimation = createSlice({
  name: "auth_animation",
  initialState,
  reducers: {
    authAnimationPoint: (state, { payload }) => {
      state.playNext = payload;
    },
  },
});

export const { authAnimationPoint } = authAnimation.actions;
export default authAnimation.reducer;
